'use strict';
import get from 'lodash/get';
import {createEventHandler} from 'recompose';
import fuse from '../../../_libs/redux-fusion';
import {
  applyDefaultReduxListComponentOptions,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {getPropsFromState} from '../../../core-utilities/redux/utils';
import {navToEntity} from '../../../app/model/actions/navigation';
import {markCommentsRead} from '../../actions';
import {reduxList} from '../../redux/chatMessageList';
import {videoSessionsActions} from '../../redux/videoSessionRequests';
import {ChatListComponent} from './ChatListComponent';
import {getUserId} from '../../../auth/reducers';
import {videoChatStartModal} from '../../redux/videoChatStartModal';


// TODO: joinVideoChat: channel has an active session and the current browser does not have an open window to that session
const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    handler: handleSubmit,
    stream: submit$,
  } = createEventHandler();

  const onSubmit = (message, callouts) => handleSubmit({message, callouts});
  submit$
    .withLatestFrom(props$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([{message, callouts}, props]) => {
      dispatch(reduxList.actions.postTextMessage({
        channel: props.parentId,
        message,
        callouts,
      }));
    });

  const onNav = channel => {
    if (get(channel, 'target.id')) {
      // dispatch action to nav to target
      dispatch(navToEntity({
        id: channel.target.id,
        collection: channel.target.collection,
      }));
    }
  };
  const onMarkCommentsRead = (channelId, count) => dispatch(markCommentsRead(channelId, count));
  // send the request to start a session
  // while loading: shw loading icon where the video chat button was
  // if successful, nav to the session
  // if error, display the error with a toast
  const onStartVideoSession = channel => {
    // if (channel && channel.session) {
    if (channel && channel.sessionStarted) {
      dispatch(videoSessionsActions.navToVideo({
        channelId: channel.id,
        sessionId: channel.session,
      }));
    } else {
      dispatch(videoChatStartModal.actions.showModal({channel}));
      // dispatch(videoSessionsActions.createSession.sendRequest({
      //   channelId: channel.id,
      // }));
    }
  };
  // navigate to the video session and make a request to join it.
  // failure to join will result:
  //   browser: in displaying an error on the new tab that you failed to join the session
  //   cordova: going back to the previous view and displaying an error with a toast
  const onJoinVideoSession = channel => dispatch(videoSessionsActions.navToVideo({
    channelId: channel.id,
    sessionId: channel.session,
  }));

  const userId$ = state$
    .map(getUserId)
    .distinctUntilChanged();

  const stateProps$ = getPropsFromState(state$, reduxList.options.getState, [
    'total',
    'readCount',
    'isLoadingReadCount',
  ]);

  return props$
    .combineLatest(
      stateProps$,
      userId$,
      (props, stateProps, userId) => ({
        ...props,
        ...stateProps,
        ...getVideoProps(props, userId),
        onNav,
        onMarkCommentsRead,
        onSubmit,
        onStartVideoSession,
        onJoinVideoSession,
      }));
};

function getVideoProps(props, userId) {
  if (!props.channel) {
    return {
      joinVideoChat: false,
      inVideoChat: false,
    };
  } else {
    return {
      joinVideoChat: !!props.channel.sessionStarted,
      inVideoChat: props.channel.sessionParticipants && props.channel.sessionParticipants[userId],
    };
  }
}

const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);
const ListComponent = ReduxListStreamedContainer(ChatListComponent, reduxList, componentOptions);
export const ChatListContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatList/ChatListContainer.js